(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ui-router-visualizer", [], factory);
	else if(typeof exports === 'object')
		exports["ui-router-visualizer"] = factory();
	else
		root["ui-router-visualizer"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/